<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Geofence</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Zone</li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Zone <span><i class="ic-tour"></i></span>
                  </h2>
                  <p>Manage zone data as part of your business offering.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Group, Zone and Country"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>
                    Country
                    <span class="button-sort" @click="onClickSort('country')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th>
                    Group
                    <span class="button-sort" @click="onClickSort('group')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th>
                    Name
                    <span class="button-sort" @click="onClickSort('name')"
                      ><i class="ic-Switch-Vertical"></i
                    ></span>
                  </th>
                  <th class="text-left">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.countryName }}</td>
                  <td>{{ item.group }}</td>
                  <td>{{ item.name }}</td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        :disabled="!isAllowToUpdate"
                        @change="changeStatus(item)"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="
                          isAllowToUpdate || isAllowToDraw || !isAllowToDraw
                        "
                        class="btn btn-default"
                        type="button"
                        @click="updateItem(item)"
                      >
                        <span>{{ isAllowToUpdate ? "Edit" : "View" }}</span>
                      </button>
                      <button
                        v-if="isAllowToDelete"
                        class="btn btn-default"
                        type="button"
                        @click="confirmDelete(item)"
                      >
                        <i class="ic-close"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="zonemodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Zone</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="form-group">
                      <label class="required">Country</label>
                      <v-select
                        class="v-search-select"
                        placeholder=""
                        label="name"
                        v-model="model.isoCountry"
                        :options="allCountries"
                        :clearable="true"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.iata"
                        :class="{
                          'field-error':
                            isSubmitted && $v.model.isoCountry.$error,
                        }"
                      >
                      </v-select>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.isoCountry.required"
                      >
                        Country is required
                      </small>
                    </div>
                    <div class="form-group" v-if="groups.length > 0">
                      <label class="cursor-pointer w-max-content">
                        <input
                          type="checkbox"
                          class="control-checkbox"
                          v-model="isUseExistingGroup"
                          @change="onChangeGroupUsing"
                        />
                        <span class="pl-5 font-weight-normal v-align-middle">
                          Use Existing Group
                        </span>
                      </label>
                    </div>
                    <div class="form-group">
                      <label class="required">Group</label>
                      <v-select
                        v-if="isUseExistingGroup && groups.length > 0"
                        class="v-search-select"
                        :class="{
                          'field-error': isSubmitted && $v.model.groupId.$error,
                        }"
                        placeholder=""
                        label="name"
                        v-model="model.groupId"
                        :options="groups"
                        :reduce="(option) => option.id"
                        :clearable="false"
                        :searchable="true"
                        :filterable="true"
                      >
                      </v-select>
                      <input
                        v-else
                        type="text"
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.model.group.$error,
                        }"
                        v-model="model.group"
                      />
                      <div
                        v-if="
                          isSubmitted &&
                          ($v.model.groupId.$error || $v.model.group.$error)
                        "
                      >
                        <small
                          class="form-text sts-danger"
                          v-if="
                            !$v.model.groupId.required ||
                            !$v.model.group.required
                          "
                          >Group is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="
                            $v.model.group.$error && !$v.model.group.maxLength
                          "
                          >Group must be less than
                          {{ $v.model.group.$params.maxLength.max }}
                          characters</small
                        >
                      </div>
                    </div>
                    <div class="form-group">
                      <label class="required">Name</label>
                      <input
                        type="text"
                        class="form-control"
                        :class="{
                          'field-error': isSubmitted && $v.model.name.$error,
                        }"
                        autocomplete="off"
                        v-model="model.name"
                      />
                      <div v-if="isSubmitted && $v.model.name.$error">
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.name.required"
                          >Name is required</small
                        >
                        <small
                          class="form-text sts-danger"
                          v-if="!$v.model.name.maxLength"
                          >Name must be less than
                          {{ $v.model.name.$params.maxLength.max }}
                          characters</small
                        >
                      </div>
                    </div>
                    <button
                      type="button"
                      id="btn-map"
                      class="btn btn-default"
                      @click.prevent="openMapModal(model)"
                    >
                      <i class="ic-map"></i>
                      Select Location by Map
                    </button>
                    <div
                      class="modal-footer"
                      v-if="
                        (!isUpdate && isAllowToCreate) ||
                        (isUpdate && isAllowToUpdate)
                      "
                    >
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" role="dialog" ref="mapmodal">
      <div class="modal-dialog modal-lg map-modal">
        <div class="modal-header modal-new" :class="{ update: isUpdate }">
          <div class="row">
            <div class="col-sm-10">
              <h4>Zone Location</h4>
              <h6 v-if="model.modifiedDate">
                Last Updated: {{ model.modifiedDate.stringFullDate }}
              </h6>
            </div>
            <div class="col-sm-2">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i class="ic-close"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <mapModal :autocomplete="true" />
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import mapModal from "@/components/shared/MapModal";
import deleteModal from "@/components/shared/DeleteModal";
import zoneService from "@/services/master/zone/zoneService.js";
import countryService from "@/services/master/countryService.js";
import maverickDrawingManager from "@/plugins/google/drawingManager.js";

export default {
  components: {
    mapModal,
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    isAllowToDraw: function () {
      return this.allPermissions.includes("Draw");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "country",
        sortDir: "asc",
      },
      isSubmitted: false,
      drawingManager: null,
      allPermissions: [],
      isUseExistingGroup: true,
      isUpdate: false,
      itemToBeDeleted: null,
      defaultCoordinates: {
        lat: null,
        lng: null,
      },
      coordinates: [],
      items: [],
      groups: [],
      allCountries: [],
      operatingCities: [],
      model: {
        groupId: null,
        group: null,
      },
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    if (this.isUseExistingGroup) {
      return {
        model: {
          isoCountry: { required },
          groupId: { required },
          group: {},
          name: { required, maxLength: maxLength(100) },
        },
      };
    } else {
      return {
        model: {
          isoCountry: { required },
          groupId: {},
          group: { required, maxLength: maxLength(100) },
          name: { required, maxLength: maxLength(100) },
        },
      };
    }
  },
  async created() {
    this.$helper.scrollTop();
    this.initGlobalSetting();

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      this.getAllGroups();
      await this.getCountries();
    }
  },
  async mounted() {
    $(this.$refs.zonemodal).on("hidden.bs.modal", this.closeModal);
    $(this.$refs.mapmodal).on("hidden.bs.modal", this.closeMapModal);

    if (!this.drawingManager) {
      const profile = await this.$store.dispatch("user/getProfile");
      const isReadOnly = profile.services[this.$route.name].includes("Draw")
        ? false
        : true;

      this.drawingManager = new maverickDrawingManager({
        mapId: "map",
        lat: this.defaultCoordinates.lat,
        lng: this.defaultCoordinates.lng,
        autocomplete: true,
        saveCallback: this.confirmPolygon,
        deleteCallback: this.deletePolygon,
        deleteAllCallback: this.deleteAllPolygon,
        readOnly: isReadOnly,
      });
    }
  },
  updated() {
    this.$helper.collapseMenu("zone");
    this.$helper.setNavigationClass("zone-link");
  },
  beforeDestroy() {
    document
      .querySelectorAll(".pac-container")
      .forEach((element) => element.remove());
  },
  methods: {
    initGlobalSetting() {
      this.$store.dispatch("setting/getAllPublic").then((publicSettings) => {
        this.table.pageSize = this.$helper.extractSetting(
          publicSettings,
          "PageSize",
          25
        );

        const defaultLatLng = this.$helper.extractSetting(
          publicSettings,
          "DefaultLatLng",
          "-6.2023616|106.8119382"
        );
        const defaultLocation = defaultLatLng.split("|");
        this.defaultCoordinates.lat = parseFloat(defaultLocation[0]);
        this.defaultCoordinates.lng = parseFloat(defaultLocation[1]);
      });
    },
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    async onClickSort(column) {
      if (this.table.sort === column) {
        this.table.sortDir = this.table.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.table.sortDir = "asc";
      }
      this.table.sort = column;
      await this.getAll();
    },
    resetModel() {
      this.model = {
        groupId: null,
        group: null,
      };
      this.coordinates = [];
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign(
        {
          groupId: null,
          group: null,
        },
        object
      );
      $(this.$refs.zonemodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.zonemodal).modal("hide");
    },
    async openMapModal(model) {
      const response = await zoneService.getLocation(model.groupId, model.id);

      if (response.main && response.main.length > 0) {
        this.coordinates = response.main;
      }

      let siblings = [];

      if (response.siblings && response.siblings.length > 0) {
        siblings = response.siblings;
      }

      this.drawingManager.load(this.coordinates, siblings);

      $(this.$refs.mapmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeMapModal() {
      $(this.$refs.mapmodal).modal("hide");
      $(this.$refs.zonemodal).css("overflow-y", "auto");
    },
    openDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal();
    },
    createItem() {
      this.isUpdate = false;
      this.isUseExistingGroup = true;
      this.resetModel();
      this.openModal({});
    },
    updateItem(item) {
      this.isUpdate = true;
      this.isUseExistingGroup = true;
      this.openModal(item);
    },
    confirmPolygon(coordinates) {
      if (
        coordinates !== undefined &&
        coordinates !== null &&
        coordinates.length > 0
      ) {
        this.coordinates = coordinates;
      } else {
        this.coordinates = [];
      }
      this.$notification.success("Location saved.", { title: "Success" });
      this.drawingManager.reset();
      this.closeMapModal();
    },
    deletePolygon() {},
    deleteAllPolygon() {},
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        if (this.table.sort && this.table.sort !== "") {
          filter += `&sort=${this.table.sort}&sortDir=${this.table.sortDir}`;
        }
        const response = await zoneService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getAllGroups() {
      this.groups = await zoneService.getAllGroups();
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;

        const isUpdate = !!this.model.id;

        if (isUpdate) {
          const payload = {
            groupId: this.model.groupId,
            groupName: this.model.group,
            name: this.model.name,
            isoCountry: this.model.isoCountry,
            coordinates: this.coordinates,
            id: this.model.id,
            isLocationUpdated: this.coordinates && this.coordinates.length > 0,
            isActive: this.model.isActive,
          };

          await zoneService.update(payload);

          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          const payload = {
            groupId: this.model.groupId,
            groupName: this.model.group,
            name: this.model.name,
            isoCountry: this.model.isoCountry,
            coordinates: this.coordinates,
          };

          await zoneService.create(payload);

          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }

        await this.getAll();
        await this.getAllGroups();

        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        item.isLocationUpdated = false;
        item.coordinates = [];
        await zoneService.update(item);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await zoneService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.getAll();
        await this.getAllGroups();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getCountries() {
      this.allCountries = await countryService.getAll();

      for (let i = 0; i < this.allCountries.length; i++) {
        const country = this.allCountries[i];
        country.label = `${country.name} (${country.iata})`;
        country.iataCode = country.iata;
      }
    },
    onChangeGroupUsing() {
      this.model.groupId = null;
      this.model.group = null;
    },
  },
};
</script>

<style>
.header-rel {
  position: relative;
  z-index: 2;
  bottom: 20px;
  margin-left: 15px !important;
  padding: 8px 20px !important;
}

.map-modal {
  width: 1400px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/master/zone/Zone.vue